"use client";

import { ProductionErrorBoundary } from "./ProductionErrorBoundary";
import { DevelopmentErrorBoundary } from "./DevelopmentErrorBoundary";

/**
 * ErrorBoundary - Conditionally exports production or development error boundary
 * based on APP_ENV environment variable:
 * - develop branch -> DevelopmentErrorBoundary
 * - main branch -> ProductionErrorBoundary
 */
const getAppEnv = (): "develop" | "production" => {
  // Check NEXT_PUBLIC_APP_ENV first (client-side accessible)
  // Fallback to APP_ENV (build-time only) or default to production
  const appEnv =
    process.env.NEXT_PUBLIC_APP_ENV ||
    process.env.APP_ENV ||
    "production";

  return appEnv === "develop" ? "develop" : "production";
};

export const ErrorBoundary =
  getAppEnv() === "develop"
    ? DevelopmentErrorBoundary
    : ProductionErrorBoundary;

